export default __webpack_public_path__ + "static/media/ladisputa.2ad86f07.png";